import Service from "../../../../utils/api/service";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _debounce from "lodash.debounce";
export default {
  name: "CreateCoupon",
  data() {
    return {
      isUpdating: false,
      isCreating: false,
      freeShipping: false,
      loading: {
        isProductSearching: false,
        isVariantSearching: false,
        customerLoading: false,
        categoryLoading: false,
        customerGroupLoading: false,
      },
      body: {
        name: "",
        code: "",
        type: "percentage",
        discount: 0,
        freeShipping: false,
        categoryId: [],
        productId: [],
        variantIds: [],
        customerGroupIds: [],
        customerIds: [],
        customerGroupAction: "include", // include | exclude
        minAmount: 0,
        minQty: 0,
        startDate: this.$moment().startOf("day").toDate(),
        endDate: this.$moment().endOf("day").toDate(),
        usesTotal: 0,
        usesCustomer: 0,
        status: "active", // active | inactive
        viewType: "select", // select | input
        customerAction: "include", // include | exclude
        minOrderOption: "minimum amount", // amount | quantity
        combineCustomerDiscount: false, // true | false
        combineProductDiscount: false, // true | false
        description: "",
      },
      data: {
        productList: [],
        categories: [],
        customers: [],
        customerGroups: [],
        variants: [],
      },
      display: {
        category: false,
      },
      model: {
        products: [],
        variants: [],
        categories: [],
        customers: [],
        customerGroups: [],
      },
      showTimePanel: false,
      showTimeRangePanel: false,
      actions: [
        { id: "include", name: "Include" },
        { id: "exclude", name: "Exclude" },
      ],
      discountTypes: [
        { id: "fix_amount", name: "Fixed Amount" },
        { id: "percentage", name: "Percentage" },
      ],
      viewTypes: [
        { id: "select", name: "User Select" },
        { id: "input", name: "User Input" },
      ],
      minOrderOptions: ["minimum amount", "minimum quantity"],
    };
  },
  components: { Multiselect, DatePicker },
  computed: {
    debouncedOnSearchProducts() {
      return _debounce(this.searchProducts, 500);
    },
    debouncedOnSearchVariants() {
      return _debounce(this.searchVariants, 500);
    },
    debouncedOnGetCustomers() {
      return _debounce(this.getCustomers, 500);
    },
  },
  created() {
    this.getCategory();
    // this.searchProducts();
    // this.getCustomers();
    this.getCustomerGroups();
  },
  methods: {
    reNewTimestamp: function (timestamp) {
      const iso = new Date(timestamp).toISOString();
      const date = new Date(iso);
      date.setUTCHours(date.getUTCHours() - 7); // Subtract 7 hours
      const newTimestamp = date.toISOString();

      return newTimestamp;
    },

    goBack() {
      this.$router.push({
        name: "ListCoupon",
        query: {
          page: 1,
          limit: 10,
        },
      });
    },

    getCategory() {
      Service.getAllCategories("").then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCategory();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.categories = response.data;
        }
      });
    },

    getCustomers(query) {
      let param = query ? "?status=active&search=" + query : "?status=active";
      this.loading.customerLoading = true;

      Service.getCustomers(param).then((response) => {
        this.loading.customerLoading = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCustomers();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let customers = response.data;
          let newList = [
            {
              name: "Select All",
              list: customers.map((item) => {
                return {
                  ...item,
                  fullName:
                    (item?.bpName
                      ? item?.bpName
                      : item?.firstName + " " + item?.lastName) +
                    " " +
                    "(" +
                    item?.code +
                    ")",
                };
              }),
            },
          ];

          this.data.customers = newList;
        }
      });
    },

    getCustomerGroups() {
      let params = "?limit=150&offset=0";
      this.loading.customerGroupLoading = true;

      Service.getCustomerGroups(params).then((response) => {
        this.loading.customerGroupLoading = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCustomerGroups();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.customerGroups = response.data;
        }
      });
    },

    showCheckboxes() {
      if (this.display.category) {
        this.display.category = false;
      } else {
        this.display.category = true;
      }
    },

    searchProducts(query) {
      let param =
        typeof query === "string" && query
          ? `?search=${query}&isOptionalPrice=true`
          : "?isOptionalPrice=true";
      this.loading.isProductSearching = true;

      Service.getAllProducts(param).then((response) => {
        this.loading.isProductSearching = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.searchProducts();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let productList = response.data;
          let newList = [
            {
              name: "Select All",
              list: productList,
            },
          ];

          this.data.productList = newList;
        }
      });
    },

    searchVariants(query) {
      let param =
        typeof query === "string" && query
          ? `?search=${query}&isOptionalPrice=true`
          : "?isOptionalPrice=true";

      this.loading.isVariantSearching = true;

      Service.getAllProductVariants(param).then((response) => {
        this.loading.isVariantSearching = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.searchVariants();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let variants = response.data;
          let newList = [
            {
              name: "Select All",
              list: variants,
            },
          ];

          this.data.variants = newList;
        }
      });
    },

    submitCreateCoupon() {
      let validatedMessage = this.validateBody(this.body);
      if (validatedMessage == "ok") {
        this.isCreating = true;
        this.createCoupon();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(body) {
      if (!body.name) {
        return "Coupon Name cannot be empty!";
      } else if (!body.code || body.code.length < 8 || body.code.length > 8) {
        return "Coupon Code cannot be empty and code must be 8 digit!";
      } else if (!body.type) {
        return "Type group cannot be empty!";
      } else if (typeof body.discount === "string" || body.discount <= 0) {
        return "Discount cannot be empty or smaller than zero!";
      } else if (typeof body.usesTotal === "string" || body.usesTotal < 0) {
        return "Uses per coupon cannot be empty or smaller than zero!";
      } else if (
        typeof body.usesCustomer === "string" ||
        body.usesCustomer < 0
      ) {
        return "Uses per customer cannot be empty or smaller than zero!";
      } else if (
        (typeof body.minAmount === "string" &&
          body.minOrderOption === this.minOrderOptions[0]) ||
        (body.minOrderOption === this.minOrderOptions[0] && body.minAmount < 0)
      ) {
        return "Minimum order amount cannot be empty or smaller than zero!";
      } else if (
        (typeof body.minQty === "string" &&
          body.minOrderOption === this.minOrderOptions[1]) ||
        (body.minOrderOption === this.minOrderOptions[1] && body.minQty < 0)
      ) {
        return "Minimum quantity of item cannot be empty or smaller than zero!";
      } else if (!body.startDate) {
        return "Start date/time cannot be empty!";
      } else if (!body.endDate) {
        return "End date/time cannot be empty!";
      } else if (!body.status) {
        return "Status order cannot be empty!";
      } else {
        return "ok";
      }
    },

    updateTimestamp: function (timestamp) {
      const iso = timestamp.toISOString();
      const date = new Date(iso);
      date.setUTCHours(date.getUTCHours() + 7); // Subtract 7 hours
      const newTimestamp = date.toISOString();

      return newTimestamp;
    },

    createCoupon() {
      this.body.productId = [];
      if (this.model.products) {
        for (let index = 0; index < this.model.products.length; index++) {
          const product = this.model.products[index];
          this.body.productId.push(product.id);
        }
      }

      this.body.customerGroupIds = [];
      if (this.model.customerGroups) {
        for (let index = 0; index < this.model.customerGroups.length; index++) {
          const customerGroup = this.model.customerGroups[index];
          this.body.customerGroupIds.push(customerGroup.id);
        }
      }

      this.body.customerIds = [];
      if (this.model.customers) {
        for (let index = 0; index < this.model.customers.length; index++) {
          const customer = this.model.customers[index];
          this.body.customerIds.push(customer.id);
        }
      }

      this.body.categoryId = [];
      if (this.model.categories) {
        for (let index = 0; index < this.model.categories.length; index++) {
          const category = this.model.categories[index];
          this.body.categoryId.push(category.id);
        }
      }

      this.body.variantIds = [];
      if (this.model.variants) {
        for (let index = 0; index < this.model.variants.length; index++) {
          const variant = this.model.variants[index];
          this.body.variantIds.push(variant.id);
        }
      }

      /***
       * @no depend field
       * @apply new field name :
       * - viewType
       * - variantIds
       * - combineCustomerDiscount
       * - combineProductDiscount
       * - customerGroupAction
       * - customerAction
       */
      const minOrder =
        this.body.minOrderOption === this.minOrderOptions[0]
          ? this.body?.minAmount ?? 0
          : this.body.minQty ?? 0;

      const body = {
        name: this.body.name,
        code: this.body.code,
        type: this.body.type,
        discount: this.body.discount ?? 0,
        freeShipping: this.body.freeShipping,
        categoryId: this.body.categoryId,
        productId: this.body.productId,
        customerIds: this.body.customerIds,
        customerGroupIds: this.body.customerGroupIds,
        minAmount:
          this.body.minOrderOption === this.minOrderOptions[0] ? minOrder : 0,
        minQty:
          this.body.minOrderOption === this.minOrderOptions[1] ? minOrder : 0,
        startDate: this.updateTimestamp(this.body.startDate),
        endDate: this.updateTimestamp(this.body.endDate),
        usesTotal: this.body.usesTotal ?? 0,
        usesCustomer: this.body.usesCustomer ?? 0,
        status: this.body.status,

        // new field
        viewType: this.body.viewType,
        customerGroupAction: this.body.customerGroupAction,
        customerAction: this.body.customerAction,
        variantIds: this.body.variantIds,
        combineCustomerDiscount: this.body.combineCustomerDiscount,
        combineProductDiscount: this.body.combineProductDiscount,
        minOrderOption: this.body.minOrderOption,
        description: this.body.description || "",
      };

      Service.createCoupon(body).then((response) => {
        this.isCreating = false;
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.createCoupon();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.resetBody();
          this.$toasted.show("Coupon has been created.");
          this.goBack();
        }
      });
    },

    resetBody() {
      this.body = {
        name: "",
        code: "",
        type: "percentage",
        discount: 0,
        freeShipping: false,
        categoryId: [],
        productId: [],
        customerGroupIds: [],
        customerIds: [],
        minAmount: 0,
        minQty: 0,
        startDate: this.$moment().startOf("day").toDate(),
        endDate: this.$moment().endOf("day").toDate(),
        usesTotal: 0,
        usesCustomer: 0,
        status: "active",
        minOrderOption: this.minOrderOptions[0],
      };
      this.model.products = [];
      this.model.categories = [];
      this.model.customers = [];
      this.model.customerGroups = [];
    },

    toUpperCase(string) {
      return string.toUpperCase();
    },

    toCapitalLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
  },
};
